export default __webpack_public_path__ + "static/media/20210430_235754-min.2641400a.jpg";